"use strict";

exports.__esModule = true;
exports.REQUIRED = exports.EMAIL = exports.EMAIL_REGEX = void 0;

/* eslint-disable */
var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable */

exports.EMAIL_REGEX = EMAIL_REGEX;

var EMAIL = function EMAIL(params) {
  if (!params.value) {
    return '';
  }

  if (typeof params.value === 'string') {
    return EMAIL_REGEX.test(params.value) ? '' : params.errorMessages.invalidEmail;
  }

  return params.errorMessages.invalidEmail;
};

exports.EMAIL = EMAIL;

var REQUIRED = function REQUIRED(params) {
  if (params.value) {
    return '';
  }

  var fieldName = params.name || 'Field';
  return params.errorMessages.requiredField.replace('$label', fieldName);
};

exports.REQUIRED = REQUIRED;